import Config from '../components/config_site.json';

const DEFAULT_CURRENCIES = [
  { code: 'DOP', symbol: 'RD$', name: 'Peso dominicano (DOP)' },
  { code: 'USD', symbol: 'US$', name: 'Dólar estadounidense (USD)' },
  { code: 'EUR', symbol: '€', name: 'Euro (EUR)' }
];

export function getCurrencyOptions() {
  if (Array.isArray(Config.currencies) && Config.currencies.length > 0) {
    return Config.currencies;
  }
  return DEFAULT_CURRENCIES;
}

export function getDefaultCurrency() {
  const options = getCurrencyOptions();
  const code = Config.default_currency || 'DOP';
  return options.find((c) => c.code === code) ? code : options[0].code;
}

export function getCurrencyMeta(code) {
  const options = getCurrencyOptions();
  return options.find((c) => c.code === code) || options[0];
}

export function getCurrencySymbol(code) {
  return getCurrencyMeta(code).symbol || code;
}

export function formatMoney(amount, currencyCode) {
  const code = currencyCode || getDefaultCurrency();
  const value = Number(amount) || 0;
  try {
    return new Intl.NumberFormat('es-DO', {
      style: 'currency',
      currency: code,
      minimumFractionDigits: 2
    }).format(value);
  } catch (_) {
    return `${getCurrencySymbol(code)} ${new Intl.NumberFormat('es-DO').format(value)}`;
  }
}

/** Moneda guardada en recibos (campo codigo_confirmacion reutilizado). */
export function getReciboCurrency(recibo) {
  const code = recibo && recibo.codigo_confirmacion;
  if (code && /^[A-Z]{3}$/.test(code)) {
    return code;
  }
  return getDefaultCurrency();
}
